import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";
import type { PaywallCheckoutPreview } from "@circle-react/types";

import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../../FirstPaymentPreview/types";
import { reducer } from "../helpers";

const buildOptions = (preview: PaywallCheckoutPreview) => {
  const results = preview.remaining_payments?.installments_preview.reduce(
    reducer,
    {
      standard: {
        quantity: 0,
        singleInstallmentAmountDue: 0,
        totalAmountDue: 0,
      },
    },
  );

  if (
    !results?.standard ||
    results?.standard.quantity === 0 ||
    results?.standard.totalAmountDue === 0
  ) {
    return { hide: true };
  }

  const valueFormatted = formatPaywallCurrencyAmount(
    preview.currency,
    results?.standard.singleInstallmentAmountDue || 0,
  );

  return {
    label: t(
      [
        "paywall_checkout.future_payments.standard_installments",
        preview.paywall_price.interval_type,
      ],
      {
        count: results?.standard.quantity,
      },
    ),
    value: `${results?.standard.quantity}x ${valueFormatted}`,
  };
};

export const StandardInstallmentsLine = ({
  preview,
}: Pick<ComponentLineProps, "preview">) => {
  const options = buildOptions(preview);
  return <DefaultFullPreview.PreviewEntry label="" {...options} />;
};
